import { Box, Button, Typography } from "@mui/material";
import { useMemo } from "react";
import { DisclosureHost } from "../hooks/use-disclosure";
import SideSheetDrawer from "./SidesheetDrawer";

interface CarePlanViewDrawerProps {
  disclosureHost: DisclosureHost;
  title?: string;
  w?: string;
}

const CarePlanViewDrawer: React.FC<CarePlanViewDrawerProps> = ({
  disclosureHost,
  title,
  w = "45vw",
}) => {
  const carePlan = disclosureHost.data;

  const sections = useMemo(() => {
    if (!carePlan?.deception) return [];
    try {
      const parsed =
        typeof carePlan.deception === "string"
          ? JSON.parse(carePlan.deception)
          : carePlan.deception;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }, [carePlan?.deception]);

  return (
    <SideSheetDrawer
      w={w}
      open={disclosureHost.opened}
      title={title ?? "View Care Plan"}
      onClose={disclosureHost.close}
      withCloseIcon={false}
      endIcon={
        <Button variant="contained" onClick={disclosureHost.close}>
          Close
        </Button>
      }
    >
      <Box sx={{ p: 2 }}>
        {carePlan?.name && (
          <Typography variant="h6" fontWeight="bold" mb={2}>
            {carePlan.name}
          </Typography>
        )}

        {carePlan?.goals ||
        carePlan?.intervention ||
        carePlan?.preventiveSchedule ? (
          <ol style={{ paddingLeft: "20px", margin: 0 }}>
            {carePlan?.goals && (
              <li style={{ marginBottom: "12px" }}>
                <Typography fontWeight="bold">Goals</Typography>
                <ul style={{ paddingLeft: "20px", marginTop: "4px" }}>
                  <li>
                    <Typography variant="body2">{carePlan.goals}</Typography>
                  </li>
                </ul>
              </li>
            )}
            {carePlan?.intervention && (
              <li style={{ marginBottom: "12px" }}>
                <Typography fontWeight="bold">Intervention</Typography>
                <ul style={{ paddingLeft: "20px", marginTop: "4px" }}>
                  <li>
                    <Typography variant="body2">
                      {carePlan.intervention}
                    </Typography>
                  </li>
                </ul>
              </li>
            )}
            {carePlan?.preventiveSchedule && (
              <li style={{ marginBottom: "12px" }}>
                <Typography fontWeight="bold">Preventive Schedule</Typography>
                <ul style={{ paddingLeft: "20px", marginTop: "4px" }}>
                  <li>
                    <Typography variant="body2">
                      {carePlan.preventiveSchedule}
                    </Typography>
                  </li>
                </ul>
              </li>
            )}
          </ol>
        ) : sections.length > 0 ? (
          <ol style={{ paddingLeft: "20px", margin: 0 }}>
            {sections.map((section, index: number) => {
              const sectionTitle = section?.title;
              const items =
                section?.[sectionTitle] ??
                Object.values(section).find((val) => Array.isArray(val));

              return (
                <li key={index} style={{ marginBottom: "12px" }}>
                  <Typography fontWeight="bold">{sectionTitle}</Typography>
                  {Array.isArray(items) && items.length > 0 && (
                    <ul style={{ paddingLeft: "20px", marginTop: "4px" }}>
                      {items.map((item: string, idx: number) => (
                        <li key={idx}>
                          <Typography variant="body2">{item}</Typography>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ol>
        ) : (
          "-"
        )}
      </Box>
    </SideSheetDrawer>
  );
};

export default CarePlanViewDrawer;
